import React from 'react';
import "./memo.css"

export default function SkillsBottom({apiData, localData, skillData}) {
  let skillDescription = []

  const expWidth = (localData.exp.currentExp * 100) / localData.exp.toNextLvl + "%"                                                                                                                                                                                                                                                                                                     
  console.log(expWidth)


  if(skillData && !Array.isArray(skillData)){
    skillDescription = skillData.flavor_text_entries.filter(skillObj => {
      if (skillObj.language.name === "en" ) {
        return skillObj.flavor_text
      }
    })
  }
  
  return (
    <div className="skills-bottom">
      <div className="bottom__item">
        <div className="bottom__item--key">EXP.</div>
        <div className="bottom__item--value-container">
          <div className="bottom__item--value">
              <span className="value__key subtitle">EXP.POINTS</span>
              <span className="value__value subtitle">{localData.exp.currentExp}</span>
          </div>
          <hr className="hr1"/>
          <hr className="hr2"/>
          <div className="bottom__item--value">
              <span className="value__key subtitle">NEXT LV.</span>
              <span className="value__value subtitle">{localData.exp.toNextLvl}</span>
          </div>
          <div className="exp-bar">
            EXP<div className="bar__content">
              <div style={{width: expWidth}}>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom__item">
          <div className="bottom__item--key">ABILITY</div>
        <div className="bottom__item--value subtitle ability">{apiData?.abilities[0]?.ability.name.toUpperCase()}</div>
      </div>
      <div className="bottom__item--value subtitle ability-description">{skillDescription[0]?.flavor_text}</div>

    </div>
  )
}
